import { gtag } from './gtag'

export function mapToolRemixEvent() {
  gtag('event', 'map_tool_remix')
}
